import React, { useEffect, useState } from "react";
import { Result, Spin } from "antd";
import Auth from "auth";
import { accessControls } from "utils";

export function useTicketAccess() {
  const [permissions, setPermissions] = useState(null);
  const isSuperAdmin = Number(Auth.getRole()) === 10;

  useEffect(() => {
    accessControls
      .fetch()
      .then(setPermissions)
      .catch(() => setPermissions({}));
  }, []);

  const canRead =
    isSuperAdmin ||
    (permissions && accessControls.can(permissions, "TicketSystem.read:any"));
  const canManage =
    isSuperAdmin ||
    (permissions && accessControls.can(permissions, "TicketManage.create:any"));

  const loading = !isSuperAdmin && permissions === null;

  return { permissions, canRead, canManage, loading, isSuperAdmin };
}

export function TicketAccessGate({ children }) {
  const { loading, canRead } = useTicketAccess();

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 80 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!canRead) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="The Ticket System is available to Super Admin only."
      />
    );
  }

  return children;
}
